import { Avatar, Tooltip } from '@mantine/core';
import { IconPhoto } from '@tabler/icons-react';
import { useState } from 'react';

import { MemberPhotoAlbumModal } from 'src/Components/Community/MemberPhotoAlbumModal';

import styles from './PhotoAlbumItem.module.scss';
import { Props } from './PhotoAlbumItem.types';

const PhotoAlbumItem = ({ memberId, firstName, lastName, profilePictureUrl }: Props) => {
  const [albumOpen, setAlbumOpen] = useState(false);
  const fullName = `${firstName} ${lastName}`;
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

  return (
    <>
      <Tooltip label={fullName}>
        <div className={styles.item} onClick={() => setAlbumOpen(true)}>
          <div className={styles.avatarContainer}>
            <Avatar src={profilePictureUrl} size={72} color="initials" name={initials}>
              {initials}
            </Avatar>
            <div className={styles.photoIcon}>
              <IconPhoto size={12} color="white" />
            </div>
          </div>
          <span className={styles.name}>{firstName}</span>
        </div>
      </Tooltip>

      <MemberPhotoAlbumModal
        memberId={memberId}
        memberName={fullName}
        opened={albumOpen}
        onClose={() => setAlbumOpen(false)}
      />
    </>
  );
};

export default PhotoAlbumItem;
